module.exports = __webpack_public_path__ + "img/hr-dry-hairy-tree-01.4ea0d1f6.png";